import { render, staticRenderFns } from "./WholesalersTransactions.vue?vue&type=template&id=44747d4a&scoped=true&"
import script from "./WholesalersTransactions.vue?vue&type=script&lang=js&"
export * from "./WholesalersTransactions.vue?vue&type=script&lang=js&"
import style0 from "./WholesalersTransactions.vue?vue&type=style&index=0&id=44747d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44747d4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VRadio,VRadioGroup,VSelect,VSpacer,VTextField,VToolbar})
